
      var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsInfo2X = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 30,
  textRendering: "geometricPrecision",
  viewBox: "0 0 32 30"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "icons-info_2x_2bed76dcd9b72f34__a",
  width: 32,
  height: 30,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAAeFBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0cwFZAAAAJ3RSTlMAUmsIxYMXquk8BXXcfzDti9G/t9niBlXzpqht5jgHc+Py6uEOgLj8rZ4MAAAACXBIWXMAAAPoAAAD6AG1e1JrAAABEElEQVR42oVT2ZaCMAwti7TIvgni7oze///DqS3YhKNDHkJIbtKsQjiKy7odhrYuY/GBgkQBRdU0VQGoJFjavQ5plls5z1J0HrdvoPyt+936Chtq3yOMuEcUYk/9x52VDsfjwUrn0cXwEE72GJqmGs4hpjyCTs3xLy/AZX5FdbaWBP67EySCED4S81Wpy9/l8KolVdYrE18oM9FK5LPit9d0coAcpeZ14TQPnYIkIYpas7YimicHVK1mQ0M0kgOaQbPbf4Db8gn54Qma5BJgkiRlLgG2TNYoDrCNYq1mgKnVdFgcMA+LjJsBovtPsFiYk7wCV2mnsXsvjFu5HoZ6Yx/p2q4t7frarx/O+ul9Pd4/susZ1CXVrmUAAAAASUVORK5CYII=",
  width: 32,
  height: 30,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAAeFBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0cwFZAAAAJ3RSTlMAUmsIxYMXquk8BXXcfzDti9G/t9niBlXzpqht5jgHc+Py6uEOgLj8rZ4MAAAACXBIWXMAAAPoAAAD6AG1e1JrAAABEElEQVR42oVT2ZaCMAwti7TIvgni7oze///DqS3YhKNDHkJIbtKsQjiKy7odhrYuY/GBgkQBRdU0VQGoJFjavQ5plls5z1J0HrdvoPyt+936Chtq3yOMuEcUYk/9x52VDsfjwUrn0cXwEE72GJqmGs4hpjyCTs3xLy/AZX5FdbaWBP67EySCED4S81Wpy9/l8KolVdYrE18oM9FK5LPit9d0coAcpeZ14TQPnYIkIYpas7YimicHVK1mQ0M0kgOaQbPbf4Db8gn54Qma5BJgkiRlLgG2TNYoDrCNYq1mgKnVdFgcMA+LjJsBovtPsFiYk7wCV2mnsXsvjFu5HoZ6Yx/p2q4t7frarx/O+ul9Pd4/susZ1CXVrmUAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAACVBMVEVMaXH///+ahv9+hP4LAAAAA3RSTlMAAQINY5SzAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAKklEQVR42mNggAMmrExqAUYCgowkaBsYwES25CgYpkFNONEy0ilRY8+8ADJGABnTz8X0AAAAAElFTkSuQmCC",
  width: 32,
  height: 30,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAACVBMVEVMaXH///+ahv9+hP4LAAAAA3RSTlMAAQINY5SzAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAKklEQVR42mNggAMmrExqAUYCgowkaBsYwES25CgYpkFNONEy0ilRY8+8ADJGABnTz8X0AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#icons-info_2x_2bed76dcd9b72f34__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h32v30H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"32\" height=\"30\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 32 30\"><defs><mask id=\"layer-0\" width=\"32\" height=\"30\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAAeFBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0cwFZAAAAJ3RSTlMAUmsIxYMXquk8BXXcfzDti9G/t9niBlXzpqht5jgHc+Py6uEOgLj8rZ4MAAAACXBIWXMAAAPoAAAD6AG1e1JrAAABEElEQVR42oVT2ZaCMAwti7TIvgni7oze///DqS3YhKNDHkJIbtKsQjiKy7odhrYuY/GBgkQBRdU0VQGoJFjavQ5plls5z1J0HrdvoPyt+936Chtq3yOMuEcUYk/9x52VDsfjwUrn0cXwEE72GJqmGs4hpjyCTs3xLy/AZX5FdbaWBP67EySCED4S81Wpy9/l8KolVdYrE18oM9FK5LPit9d0coAcpeZ14TQPnYIkIYpas7YimicHVK1mQ0M0kgOaQbPbf4Db8gn54Qma5BJgkiRlLgG2TNYoDrCNYq1mgKnVdFgcMA+LjJsBovtPsFiYk7wCV2mnsXsvjFu5HoZ6Yx/p2q4t7frarx/O+ul9Pd4/susZ1CXVrmUAAAAASUVORK5CYII=\" width=\"32\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAAeFBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0cwFZAAAAJ3RSTlMAUmsIxYMXquk8BXXcfzDti9G/t9niBlXzpqht5jgHc+Py6uEOgLj8rZ4MAAAACXBIWXMAAAPoAAAD6AG1e1JrAAABEElEQVR42oVT2ZaCMAwti7TIvgni7oze///DqS3YhKNDHkJIbtKsQjiKy7odhrYuY/GBgkQBRdU0VQGoJFjavQ5plls5z1J0HrdvoPyt+936Chtq3yOMuEcUYk/9x52VDsfjwUrn0cXwEE72GJqmGs4hpjyCTs3xLy/AZX5FdbaWBP67EySCED4S81Wpy9/l8KolVdYrE18oM9FK5LPit9d0coAcpeZ14TQPnYIkIYpas7YimicHVK1mQ0M0kgOaQbPbf4Db8gn54Qma5BJgkiRlLgG2TNYoDrCNYq1mgKnVdFgcMA+LjJsBovtPsFiYk7wCV2mnsXsvjFu5HoZ6Yx/p2q4t7frarx/O+ul9Pd4/susZ1CXVrmUAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAACVBMVEVMaXH///+ahv9+hP4LAAAAA3RSTlMAAQINY5SzAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAKklEQVR42mNggAMmrExqAUYCgowkaBsYwES25CgYpkFNONEy0ilRY8+8ADJGABnTz8X0AAAAAElFTkSuQmCC\" id=\"convert2-underlay\" width=\"32\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAAACVBMVEVMaXH///+ahv9+hP4LAAAAA3RSTlMAAQINY5SzAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAKklEQVR42mNggAMmrExqAUYCgowkaBsYwES25CgYpkFNONEy0ilRY8+8ADJGABnTz8X0AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/><rect width=\"32\" height=\"30\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-info@2x.2bed76dcd9b72f34171ee10e96128b80.svg"),
        {
          React: SvgIconsInfo2X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      